module.exports = __webpack_public_path__ + "static/media/medal.e0370dd9.svg";